import React from "react";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import PlusIcon from "@material-ui/icons/Add";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

const headRows = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Ad",
  },
  {
    id: "tools",
    numeric: false,
    disablePadding: false,
    label: "Əməliyyatlar",
  },

];

function EnhancedTableHead(props) {
  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
          >
            <TableSortLabel
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}


const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: "flex-end",
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  dense: {
    margin: theme.spacing(2),
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    numSelected,
    setShowCreate,
    permissionList
  } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >

      <div className={classes.actions}>
      {permissionList.some(element => element === "create_card_employee") &&

        <Tooltip title="Əlavə et" placement="top">
          <button
            className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
            onClick={() => setShowCreate(true)}
          >
            <PlusIcon />
          </button>
        </Tooltip>}
      </div>
    </Toolbar>
  );
};


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
}));

export default function EnhancedTable({
  logRows,
  isLoading,
  isError,
  setText,
  setLogId,
  setShowCreate,
  setShowRemove,
  setShowRemoveProspekts,

}) {


  const classes = useStyles();
  const permissionList = useSelector(state => state.auth.permissionList)

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
      {isLoading && (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      )}
        <EnhancedTableToolbar
          setText={setText}
          setShowCreate={setShowCreate}
          permissionList={permissionList}
          setShowRemoveProspekts={setShowRemoveProspekts}
        />
       
     
          <div className={classes.tableWrapper}>
          {logRows ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                rowCount={logRows.length}
              />
              <TableBody>
               
                    <TableRow hover tabIndex={-1} key={logRows.id}>
                      <TableCell component="th" id={logRows.id} scope="row">
               {logRows.name} - {logRows.number}
                        
                      </TableCell>
                      <TableCell component="th" id={logRows.id} scope="row">
                       { permissionList.some(element => element === "delete_card_employee") && 

                        <Tooltip title="Sil" placement="top">
                          <button
                            aria-label="delete"
                            className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger mr-2"
                            onClick={(e) => {
                              setLogId(logRows.id);
                              setShowRemove(true);
                            }}
                          >
                          <DeleteIcon />
                          </button>
                        </Tooltip>}
                        
                      </TableCell>
                      
                    </TableRow>
                
              
              </TableBody>
            </Table>
            ) :  !logRows && !isLoading && !isError ? (
              <div className="noInfo">
                <img
                  src="/media/error/search.png"
                  className="info-img"
                  alt="information"
                />
                <h4>İnformasiya tapılmadı</h4>
              </div>
            ) : (
              !isLoading &&
              isError && (
                <div className="noInfo">
                  <img
                    src="/media/error/connect.png"
                    className="info-img"
                    alt="connection"
                  />
                  <h4>Bağlantı yoxdur</h4>
                </div>
              )
            )}
        </div>

      </Paper>
    </div>
  );
}
